// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__zozKS","upload":"Small_upload__147eK","imageWrap":"Small_imageWrap__1raY1","removeBtn":"Small_removeBtn__395Wj"};